import styled from 'styled-components';
import { filterBreakpoint } from './SearchBar.style';

export const PreferenceColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;

  &:first-child {
    margin-right: 30px;
  }

  @media (${filterBreakpoint}) {
    width: 100%;
    &:first-child {
      margin-right: 0;
    }
  }
`;

export const PreferenceRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px 40px;

  @media (${filterBreakpoint}) {
    gap: 20px 15px;

    & > div {
      flex-basis: calc(50% - 15px);
    }
  }
`;
